export default __webpack_public_path__ + "static/media/alert.9f2cd4b0.svg";